var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExAirlineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 64.67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 107.62,
    x2: 107.62,
    y1: 33.59,
    y2: 39.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2001c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#df001e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d8001e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d5001e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cb001e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c1081e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#b60c1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a70d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9b0e1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8c0e1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c0f16"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 102.917,
    x2: 106.338,
    y1: 34.926,
    y2: 32.735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#581718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6a1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#831c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#a31f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc1f1e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 102.429,
    x2: 107.439,
    y1: 33.868,
    y2: 30.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#d7dce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bec6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97a5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80949c"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 100.765,
    x2: 100.765,
    y1: 24.91,
    y2: 30.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#159ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1397d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1490d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1489ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#137ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1473b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1467a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#115b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#114e91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#123f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143272"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m103.42 35.69 1.71 2.83c.53.85 1.4 1.23 2.48 1.23h4.39l-5.14-6.22-.73-.41-1.92.63-.97 1.41s.18.53.18.53z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m106.86 33.54-1.07-1.3-2.83 1.52.3 1.54.16.39c-.06-1.04 1.73-2.25 3.44-2.16z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m103.42 35.69-1.53-2.54c-.18-.29-.24-.54-.24-.83 0-.32.14-.5.67-.78.61-.29 1.85-.42 3.13-.42 2.07 0 2.57.67 2.78 1.38 0 0-.29-.12-.98-.12-2.19 0-3.93 1.06-3.93 2.67 0 .34.1.64.1.64z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m96.84 24.91h2.06c.87 0 1.23.36 1.58.7.4.37 1.62 2.02 4.21 5.25h-2.79c-1.14 0-1.5-.19-1.95-.87z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m64.57 30.86h-.02l-1.17 3.32h2.37s-1.18-3.32-1.18-3.32zm2.1 5.93-.57-1.63h-3.07l-.58 1.63h-1.31l2.75-7.26h1.46l2.71 7.26zm11.13-7.54h1.28v1.21h-1.28zm.01 2.02h1.25v5.53h-1.25zm-9.26-2.02h1.28v1.21h-1.28zm.02 2.02h1.25v5.53h-1.25zm7.88-2.01h-1.25v7.54h1.25zm-4 4.84v2.7h-1.26v-4.11c0-.39-.05-1.15-.06-1.42h1.01c.11 0 .14.05.14.15 0 .16.01.68.01.68h.03c.1-.24.46-.95 1.5-.95.35 0 .61.11.65.13 0 .24-.02.76-.04.9 0 .09-.05.12-.09.12s-.06 0-.09-.02c-.08-.03-.26-.09-.51-.09-.67 0-1.3.48-1.3 1.91zm11.42 2.69v-3.57c0-.68-.31-1.1-.89-1.1-.77 0-1.28.82-1.28 1.93v2.74h-1.25v-4.06c0-.45-.04-1.1-.06-1.47h1.01c.11 0 .15.05.15.15 0 .12.01.69.01.69h.03c.15-.26.54-.96 1.69-.96s1.86.82 1.86 1.73v3.91h-1.25zm3.47-3.33h2.32c.05-.89-.42-1.39-1.13-1.39s-1.16.53-1.2 1.39zm3.1 2.12c.07 0 .09.06.1.12.02.24.04.77.04.9-.13.04-.81.29-1.71.29-1.76 0-2.82-.91-2.82-2.87 0-1.68.9-2.88 2.52-2.88s2.35 1.07 2.35 2.39c0 .16-.02.42-.04.77h-3.54c0 .94.6 1.62 1.71 1.62.61 0 1.1-.22 1.29-.31.04-.02.06-.03.11-.03zm2.93 1.32c1.63 0 2.41-.67 2.41-1.66s-.69-1.39-1.43-1.63c-.21-.07-.42-.14-.61-.2-.5-.17-.76-.39-.76-.71 0-.34.31-.59.97-.59.58 0 1.05.24 1.24.33.03.01.06.03.11.03.04 0 .09-.02.1-.12.01-.19.03-.52.03-.84-.15-.07-.7-.35-1.58-.35-1.35 0-2.18.7-2.18 1.63s.61 1.31 1.29 1.53c.16.05.44.15.61.2.7.23.91.45.91.78 0 .43-.46.64-1.25.64-.65 0-1.09-.24-1.27-.32-.04-.02-.06-.03-.11-.03-.09 0-.09.12-.1.14 0 .06-.03.63-.03.82.15.06.79.35 1.65.35zm-73.94-6.04h-.02l-1.17 3.32h2.37l-1.17-3.32zm2.11 5.93-.58-1.63h-3.07l-.58 1.63h-1.31l2.75-7.26h1.46l2.71 7.26h-1.39zm20.49-7.54h1.28v1.21h-1.28zm.02 2.02h1.25v5.53h-1.25zm-2.69 2.83v2.7h-1.26v-4.11c0-.4-.05-1.15-.06-1.42h1.01c.11 0 .14.05.14.15 0 .16.01.69.01.69h.03c.1-.24.46-.95 1.5-.95.35 0 .61.11.65.13 0 .24-.03.76-.04.9 0 .09-.05.12-.09.12s-.06 0-.09-.02c-.08-.03-.26-.09-.51-.09-.67 0-1.3.48-1.3 1.91zm-9.27 2.69v-3.54c0-.64-.27-1.13-.92-1.13-.73 0-1.15.8-1.15 1.92v2.74h-1.25v-3.55c0-.58-.24-1.12-.91-1.12-.74 0-1.16.8-1.16 1.96v2.7h-1.26v-4.03c0-.52-.05-1.26-.06-1.5h1c.11 0 .15.04.15.15 0 .15.01.69.01.69h.03c.08-.16.49-.96 1.64-.96 1.07 0 1.48.77 1.59 1.01.1-.21.58-1.01 1.66-1.01s1.89.6 1.89 1.82v3.83h-1.25zm3.47-3.33h2.32c.05-.89-.42-1.39-1.13-1.39s-1.16.53-1.2 1.39zm3.1 2.12c.07 0 .09.06.1.12.02.24.04.77.04.9-.13.04-.81.29-1.71.29-1.76 0-2.82-.91-2.82-2.87 0-1.68.9-2.88 2.53-2.88s2.35 1.06 2.35 2.39c0 .16-.02.42-.05.77h-3.54c0 .94.6 1.62 1.71 1.62.61 0 1.1-.22 1.29-.31.04-.02.06-.03.11-.03zm15.73-1.59h-.21c-1.58 0-1.89.55-1.89 1.1 0 .46.3.89.89.89.78 0 1.21-.76 1.21-1.55zm.3 2.8c-.1 0-.19-.03-.2-.18-.01-.18-.04-.53-.04-.53h-.02c-.07.1-.53.82-1.68.82s-1.73-.85-1.73-1.78c0-1.29 1.25-1.94 3.11-1.94h.25v-.2c0-.58-.41-.89-1.18-.89-.69 0-1.27.24-1.49.36-.01 0-.06.03-.09.03-.06 0-.09-.04-.1-.1-.01-.21-.03-.61-.03-.86.23-.09.98-.36 1.8-.36 1.64 0 2.35.76 2.35 1.98v2.15c0 .79.07 1.3.1 1.51h-1.05zm-4.33-1.21s.08.02.09.12c.02.26.03.69.04.83-.25.12-.79.37-1.46.37-1.67 0-2.7-.97-2.7-2.87 0-1.78.91-2.87 2.7-2.87.59 0 1.14.21 1.46.37 0 .2-.02.64-.04.83 0 .08-.05.12-.09.12-.05 0-.07-.01-.1-.03-.4-.2-.78-.29-1.13-.29-1.07 0-1.5.7-1.5 1.88 0 1.05.35 1.87 1.5 1.87.44 0 .84-.16 1.09-.28.07-.03.08-.04.13-.04zm9.81 1.21v-3.57c0-.68-.31-1.1-.89-1.1-.77 0-1.29.82-1.29 1.93v2.74h-1.25v-4.06c0-.45-.04-1.1-.06-1.47h1.01c.11 0 .15.05.15.15 0 .12.01.69.01.69h.03c.15-.26.54-.96 1.69-.96s1.86.82 1.86 1.73v3.91h-1.26z",
    fill: "#273345"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0 64.67h128v64.67h-128z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExAirlineLogo);
export default __webpack_public_path__ + "static/media/ex_airline_logo.d7bbf6e20b54ddfd428afdb60648cf52.svg";
export { ForwardRef as ReactComponent };